import type { FC } from 'react';

import { ArrowDownIcon, ArrowUpIcon } from '@eneco/sparky/icons';
import { CircleShape } from '@visx/legend';


import { DashedLine } from './DashedLine';
import { graphColors } from '../../../../utils/constants';
import { Legend } from '../../../../utils/types';

type Props = {
  type: Legend;
};

export const LegendIcon: FC<Props> = ({ type }) => {
  switch (type) {
    case 'electricityProduct':
      return <CircleShape fill={graphColors[type]} width={15} height={15} />;
    case 'gasProduct':
      return <CircleShape fill={graphColors[type]} width={15} height={15} />;
    case 'cheapTariff':
      return <ArrowDownIcon color={'feedbackSuccess'} />;
    case 'expensiveTariff':
      return <ArrowUpIcon color={'feedbackError'} />;
    case 'averagePrice':
      return <DashedLine color={graphColors['averagePrice']} />;
    case 'unknownPrice':
    default:
      return <CircleShape fill={graphColors[type]} width={15} height={15} />;
  }
};
